import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthenticationService } from "../services/authentication.service";
import { JwtHelperService } from "@auth0/angular-jwt";

@Injectable({
  providedIn: "root"
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {

    const urlToken = route.queryParams['token'];
    if (urlToken) {
      const isValid = this.authenticationService.authenticateWithUrlToken(urlToken);

      if (isValid) {
        return true;
      } else {
        this.router.navigate(['/login']);
        return false;
      }
    }

    const storedToken = localStorage.getItem('merchant_token');
    if (storedToken) {
      const helper = new JwtHelperService();
      const isExpired = helper.isTokenExpired(storedToken);

      if (!isExpired) {
        return true;
      }
    }

    // const currentUser1 = this.authenticationService.currentUserValue;
    // if (currentUser1) {
    //   // authorised so return true
    //   return true;
    // }

    // not logged in so redirect to login page with the return url
    this.router.navigate(["/login"]);

    return false;
  }
}
